// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"0dbdc064","977":"7450fcea"}[chunkId] + ".chunk.js";
};